import { client } from "../../../Infrastructure/agent";

export const SettingService = {
  loadEbendoSettings: () =>
    client.get("/setting/LoadEbendoReportInputSettings"),
  saveFlasSettings: (setting, uploadedBy) =>
    client.post("/setting/SaveEbendoReportInputSettings", {
      setting,
      uploadedBy,
    }),
};

